/* eslint-disable */
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { getStore } from '../Search/State/store.js'
import EventDateController from './ComponentsAir/EventDateController.js'


class EventInterface {
  static mount (mountPoint) {
    var store = getStore()
    ReactDOM.render(
      <Provider store={store}>
        <EventDateController />
      </Provider>,
      mountPoint
    )
  }
}

window.Foundation.EventInterface = EventInterface

